import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import StepperNavigationButtons from "../StepperNavigationButtons";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const ThemeCustomization = forwardRef((props, ref) => {
  const [errors, setErrors] = useState({});
  const slide1ImageRef = useRef();
  const slide2ImageRef = useRef();
  const slide3ImageRef = useRef();

  const [slide1ImageKey, setSlide1ImageKey] = useState(null);
  const [slide2ImageKey, setSlide2ImageKey] = useState(null);
  const [slide3ImageKey, setSlide3ImageKey] = useState(null);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [file3, setFile3] = useState(null);
      const [banners, setBanners] = useState({
        banner1: { title: '', description: '' },
        banner2: { title: '', description: '' },
        banner3: { title: '', description: '' },
      });
      const handleChange = (bannerKey, field, value) => {
        setBanners(prev => ({
          ...prev,
          [bannerKey]: {
            ...prev[bannerKey],
            [field]: value
          }
        }));
      };
  useEffect(() => {
    resetData();
    if (props.data) {
      if (props.data.length > 0) {
        setSlide1ImageKey(props.data[0].imageKey);
        slide1ImageRef?.current?.setThumbnail(props.data[0].image);
        slide1ImageRef?.current?.setFileContent(props.data[0].imageFile);
      }
      if (props.data.length > 1) {
        setSlide2ImageKey(props.data[1].imageKey);
        slide2ImageRef?.current?.setThumbnail(props.data[1].image);
        slide2ImageRef?.current?.setFileContent(props.data[1].imageFile);
      }
      if (props.data.length > 2) {
        setSlide3ImageKey(props.data[2].imageKey);
        slide3ImageRef?.current?.setThumbnail(props.data[2].image);
        slide3ImageRef?.current?.setFileContent(props.data[2].imageFile);
      }
    }
  }, [props.data]);

  const resetData = () => {
    slide1ImageRef?.current?.setThumbnail(null);
    slide1ImageRef?.current?.setFileContent(null);
    slide2ImageRef?.current?.setThumbnail(null);
    slide2ImageRef?.current?.setFileContent(null);
    slide3ImageRef?.current?.setThumbnail(null);
    slide3ImageRef?.current?.setFileContent(null);
    setSlide1ImageKey(null);
    setSlide2ImageKey(null);
    setSlide3ImageKey(null);
  };

  const validate = () => {
    const errors = {};
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getData = () => {
    let sliders = [];

    if (slide1ImageRef?.current?.getThumbnail()) {
      
      sliders.push({
        image: slide1ImageRef?.current?.getThumbnail(),
        imageFile: slide1ImageRef?.current?.getImageFile(),
        imageKey: slide1ImageKey,
        banner1title: banners.banner1.title,
        banner1description: banners.banner1.description,
      });
    }
    if (slide2ImageRef?.current?.getThumbnail()) {
      
      sliders.push({
        image: slide2ImageRef?.current?.getThumbnail(),
        imageFile: slide2ImageRef?.current?.getImageFile(),
        imageKey: slide2ImageKey,
        banner2title: banners.banner2.title,
        banner2description: banners.banner2.description,
      });
    }
    if (slide3ImageRef?.current?.getThumbnail()) {
      ;
      sliders.push({
        image: slide3ImageRef?.current?.getThumbnail(),
        imageFile: slide3ImageRef?.current?.getImageFile(),
        imageKey: slide3ImageKey,
        banner3title: banners.banner3.title,
        banner3description: banners.banner3.description,
      });
    }

    return sliders;
  };

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate,
  }));
  const handleCroppedImage1 = (file) => {
   setFile1(file)
   const sliders = [
    {image1: file,
    image2: file2,
    image3: file3,
  }]
if (props.section) {
props.section(sliders)
}
  };
  const handleCroppedImage2 = (file) => {
   setFile2(file)
   const sliders = [
    {image1: file1,
    image2: file,
    image3: file3,
  }]
if (props.section) {
props.section(sliders)
}
  };
  const handleCroppedImage3 = (file) => {
   setFile3(file)
   const sliders = [
    {image1: file1,
    image2: file2,
    image3: file,
  }]
if (props.section) {
props.section(sliders)
}
  };
  console.log("banners",banners)
  return (
    <div className="content d-block visible">
      <div className="content-header mb-3 d-flex justify-content-between flex-column flex-md-row">
        <div >
          <h2 className="text-primary">Sliders</h2>
          {/* <div className="title-shape"></div> */}
          <small className="fs-11 mb-0">You can set up to 3 banners, each file size should not exceed 1MB</small>
          <br />
          <small className="fs-11 mb-0">Dimension: 1920px x 942px</small>
        </div>
      </div>
      <div className="row g-3">
        {errors.noSlider && (
          <div style={{ color: "#ea5455", fontSize: "0.8125rem" }}>{errors.noSlider}</div>
        )}
        <div className="col-sm-4">
          <label className="form-label" htmlFor="slide1Image">Banner 1</label>
          <ImageBrowse 
            elementId="slide1Image" 
            ref={slide1ImageRef} 
            imageType="slider"
            imageKey={slide1ImageKey} 
            setImageKey={setSlide1ImageKey} 
            imageDelete={props.imageDelete} 
            onImageCropped={handleCroppedImage1}
          />

<div className="col-sm-12">
              <label className="form-label" htmlFor="section2Name">
              Banner header
              </label>
              <input
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control`}
                  value={banners.banner1.title}
                  onChange={(e) => handleChange("banner1","title",e.target.value)}
              />
            </div>
            <div className="col-sm-12">
              <label className="form-label" htmlFor="section2Name">
              Banner Destructure
              </label>
              <textarea
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control `}
                value={banners.banner1.description}
                onChange={(e) => handleChange("banner1","description",e.target.value)}
                style={{ height: "100px", resize: "none" }}
              />
             
            </div>
        </div>
        <div className="col-sm-4">
          <label className="form-label" htmlFor="slide2Image">Banner 2</label>
          <ImageBrowse 
            elementId="slide2Image" 
            ref={slide2ImageRef} 
            imageType="slider"
            imageKey={slide2ImageKey} 
            setImageKey={setSlide2ImageKey} 
            imageDelete={props.imageDelete} 
            onImageCropped={handleCroppedImage2}

          />
          <div className="col-sm-12">
              <label className="form-label" htmlFor="section2Name">
              Banner header
              </label>
              <input
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control`}
                  value={banners.banner2.title}
                  onChange={(e) => handleChange("banner2","title",e.target.value)}
              />
            </div>
            <div className="col-sm-12">
              <label className="form-label" htmlFor="section2Name">
              Banner Destructure
              </label>
              <textarea
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control `}
                value={banners.banner2.description}
                onChange={(e) => handleChange("banner2","description",e.target.value)}
                style={{ height: "100px", resize: "none" }}
              />
             
            </div>
        </div>
        <div className="col-sm-4">
          <label className="form-label" htmlFor="slide3Image">Banner 3</label>
          <ImageBrowse 
            elementId="slide3Image" 
            ref={slide3ImageRef} 
            imageType="slider"
            imageKey={slide3ImageKey} 
            setImageKey={setSlide3ImageKey} 
            imageDelete={props.imageDelete} 
            onImageCropped={handleCroppedImage3}

          />
          <div className="col-sm-12">
              <label className="form-label" htmlFor="section2Name">
              Banner header
              </label>
              <input
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control`}
                  value={banners.banner3.title}
                  onChange={(e) => handleChange("banner3","title",e.target.value)}
              />
            </div>
            <div className="col-sm-12">
              <label className="form-label" htmlFor="section2Name">
              Banner Destructure
              </label>
              <textarea
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control `}
                value={banners.banner3.description}
                onChange={(e) => handleChange("banner3","description",e.target.value)}
                style={{ height: "100px", resize: "none" }}
              />
             
            </div>
        </div>
        <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} save={props.save} />
      </div>
    </div>
  );
});

export default ThemeCustomization;
